export default __webpack_public_path__ + "static/media/ser-label.0ef3b72c.svg";